<template>
    <div class="wrapper landing-page">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/tjn-bck.jpg')">
            </parallax>
            <div class="content-center">
                <h1 class="title">{{webSiteBilgileri.PodCastAdi}}</h1>
                <h5 class="description">{{webSiteBilgileri.Slogan}}</h5>
                <div class="text-center">
                    <a href="https://www.instagram.com/tijenhoca/" class="btn btn-primary btn-icon  btn-round">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="https://twitter.com/tijentangulse" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.facebook.com/pages/Tijen-Hoca/208586643077901" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-facebook"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="features-5">
<!--            <h3>{{statikSayfalars}}</h3>-->
            <div class="container" v-if="statikSayfalars.length > 0">
                <div class="row">
                    <h1 class="title">{{statikSayfalars[0].SayfaAdi}}</h1>
                </div>
                <div class="row">
                    <VueShowdown :markdown="statikSayfalars[0].icerik"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Tabs, TabPane } from '@/components';
  import gql from "graphql-tag";
  export default {
    name: 'landing-page',
    bodyClass: 'landing-page',
    components: {
      Card,
      Tabs,
      TabPane,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        form: {
          firstName: '',
          email: '',
          message: '',
        },
        webSiteBilgileri: {SiteAdi: '', KatildigimIsler:[]},
        statikSayfalars: {},
        frontend_address: process.env.VUE_APP_FRONTEND_ADDRESS,
        routeParam: this.$route.params.sid
      }
    },
    apollo: {
      webSiteBilgileri: {
        query:gql`
      query webSiteBilgileri {
        webSiteBilgileri {
          id
          SiteAdi
          tags
          PodCastAdi
          PodCastKonusu
          Slogan
          created_at
          updated_at
          podcast_image {
            url
          }
          KatildigimIsler {
            id
            Baslik
            KisaAciklama
            icon
            ArkaPlanResmi {
              url
              previewUrl
            }
            link
          }
        }
      }
    `
      },
      statikSayfalars:{
        query:gql`
           query statikSayfalars($sid: String) {
                statikSayfalars(where : {sid: $sid}) {
                    sid
                    SayfaAdi
                    icerik
                }
           }
        `,
          variables() {
            return {
              sid: this.routeParam
            };
          }
        }
    }
  }
</script>
<style>
</style>
